import { get, put } from '../axios'
import axios from "axios";

// 负载识别数据-列表
export const loadList = params => get(`/web/waveform/load/list`,params);

// 负载识别数据-源数据下载
export const loadDownload = params => {
  return axios.get(`/web/waveform/load/download/` + params, {
    responseType: 'stream', 
    headers: {
      'X-Download': 'true' // 添加自定义头部标识文件下载
    }
  });
};
// 负载识别数据-查看波形
export const loadWaveView = params => get(`/web/waveform/load/wave/view/`+params, '');

// 负载识别数据-纠错
export const loadCorrect = params => put(`/web/waveform/load/correct`,params);